// extracted by mini-css-extract-plugin
export default {"codarx_splash":"styles_codarx_splash__8eDD1"};